module.exports = __webpack_public_path__ + "img/e1a1a1c.jpg";